module.exports = __webpack_public_path__ + "static/media/logo_topbar.382be839.svg";